export const PREDICTIVE_SUGGESTION = {
  USER_ACCOUNT_GREY_LISTED: 'USER_ACCOUNT_GREY_LISTED',
  FAILED_DEPOSIT_IN_THE_PAST_6_HOURS: 'FAILED_DEPOSIT_IN_THE_PAST_6_HOURS',
  FAILED_WITHDRAWS_IN_THE_PAST_6_HOURS: 'FAILED_WITHDRAWS_IN_THE_PAST_6_HOURS',
  LOST_BET_IN_THE_PAST_6_HOURS: 'LOST_BET_IN_THE_PAST_6_HOURS',
  UNSETTLED_BET_IN_THE_PAST_6_HOURS: 'UNSETTLED_BET_IN_THE_PAST_6_HOURS',
  VOIDED_BET_IN_THE_PAST_6_HOURS: 'VOIDED_BET_IN_THE_PAST_6_HOURS',
} as const;

export type PredictiveSuggestions = (typeof PREDICTIVE_SUGGESTION)[keyof typeof PREDICTIVE_SUGGESTION];
